import React from 'react';
import { Icon ,Modal,IconButton,Panel,ButtonToolbar,Button,ButtonGroup,PanelGroup} from 'rsuite';
import VideoModal from './videoModal';
import HelpPanel from './helpPanel';
import TargetPanel from './targetPanel';
const navstyle={
    position:"fixed",
    width:"400px",
    zIndex:99,
    top:"10px",
    right:"10px"
}
const cdut = {
  xueyuan : "成都理工大学地球物理学院",
  email : "联系邮箱：jiansir@163.com"
}
const ncwu = {
  xueyuan : "华北水利水电大学地球科学与工程学院",
  email : "联系邮箱：jiansir@163.com"
}
  class ONavBar extends React.Component {
    constructor(props) {
      super(props);
      this.state={
          showvideo:false,
          showtarget:false,
          showabout:false,
          showuse:false,
      }
  }
  videoopen=()=>{
      this.setState({ 
        showvideo: true ,
        showtarget:false,
          showabout:false,
          showuse:false
      });
  }
  videoclose=()=>{
      this.setState({ showvideo: false });
  }

    handleFullScreen=()=>{
      var app=document.getElementById('root');
      if (app.requestFullscreen) {
        app.requestFullscreen();
    }
    }

    targetopen=()=>{
      this.setState({
         showtarget: true ,
         showvideo:false,
         showabout:false,
         showuse:false
      });
    }

    targetclose=()=>{
      this.setState({ showtarget: false });
    }

    aboutopen=()=>{
      this.setState({
         showabout: true ,
         showtarget:false,
          showvideo:false,
          showuse:false
        });
    }

    aboutclose=()=>{
      this.setState({ showabout: false });
    }

    useopen=()=>{
      this.setState({ 
        showuse: true ,
        showtarget:false,
          showabout:false,
          showvideo:false
      });
    }

    useclose=()=>{
      this.setState({ showuse: false });
    }

    render() {
      const schoolA = ncwu;
      const schoolB = cdut;
      return (
        <div style={navstyle}>
        <ButtonToolbar >
          <IconButton icon={<Icon icon="home" />}  appearance="primary" href="/"/>
          <ButtonGroup>
            <Button onClick={this.targetopen}>系统说明</Button>
            <Button onClick={this.videoopen}>视频说明</Button>
            <Button onClick={this.useopen}>使用说明</Button>
            <Button onClick={this.aboutopen}>关于</Button>
            <IconButton icon={<Icon icon="arrows-alt"/>} onClick={this.handleFullScreen} />
          </ButtonGroup>
      </ButtonToolbar>

      <VideoModal 
        showvideo={this.state.showvideo} 
        videoclose = {this.videoclose}
      />

      <TargetPanel 
        showtarget = {this.state.showtarget}
        targetclose = {this.targetclose}
      />

      <Modal show={this.state.showabout} onHide={this.aboutclose}  overflow>
          <Modal.Header>
            <Modal.Title>关于我们</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div>
            <strong>{schoolA.xueyuan}</strong>
            <br/>
            {schoolA.email}
            <br/><br/>
            <strong>{schoolB.xueyuan}</strong>
            <br/>
            {schoolB.email}
          </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.aboutclose}  appearance="primary">
              联系我们
            </Button>
          </Modal.Footer>
      </Modal>

      <HelpPanel
          showuse = {this.state.showuse}
          useclose = {this.useclose}
      />
      </div>
      );
    }
  }
  export default ONavBar;